import React, { Component } from 'react';
import './NavBar.css';
import logo from 'assets/logo-new.svg';
import hamburgerIcon from 'assets/hamburger-menu.svg';
import history from '../../history';
import classNames from 'classnames';
import models from "../../model/models";
import AccountOptions from "../accountOptions/AccountOptions";
export default class NavBar extends Component {
	constructor(props) {
		super(props);
		this.state = {
			url: window.location.pathname,
			mobileMenuOpen: false
		};
	}

	componentDidMount = () => {
		history.onChange((url) => {
			this.setState({ url });
		});
    this.userGroupSubId = models.user_group.onChange(this.updateUserGroup)

		window.addEventListener('keyup', (event) => {
		if (event.keyCode !== 13) {
			return;
		}
			this.OnEnterPress();
		});

		this.handleOutsideClick = (event) => {
			if (this.state.mobileMenuOpen) {
				const menuElement = this.menuRef;
				const hamburgerInsideElement = this.hamburgerInsideRef;
				
				if (
					menuElement &&
					!menuElement.contains(event.target) &&
					!(hamburgerInsideElement && hamburgerInsideElement.contains(event.target))
				) {
					setTimeout(this.closeMobileMenu, 100);
				}
			}
		};

		document.body.addEventListener('click', this.handleOutsideClick, true);
	};

	componentWillUnmount() {
		models.user_group.unsubscribe(this.userGroupSubId)
		window.removeEventListener('keyup', (event) => {
			if (event.keyCode !== 13) {
				return;
			}
			this.OnEnterPress();
		});
		if (this.handleOutsideClick) {
			document.body.removeEventListener('click', this.handleOutsideClick, true);
		}
	}

  updateUserGroup = () => {
    this.setState({userGroup:models.user_group.obj()})
  };

	isActiveTab = (routes, exact) => {
		for (let i in routes){
		  if(this._isActive(routes[i], exact)){
				return true;
			}
		}
		return false;
	}
	_isActive = (route, exact) => {
		if (exact) {
			if (this.state.url === route) {
				return true;
			}
			return false;
		} else if (this.state.url.indexOf(route) === 0) {
			return true;
		}
		return false;
	};

	OnEnterPress = () => {
		console.log(localStorage.token);
		if(document.activeElement.onClick !== null){
			document.activeElement.click()
		}
	}

	canSelectWithTab = () => {
		// let popupOpen = this.checkPopupOpen();
		// if(popupOpen) return -1;
		if(!localStorage.token) return -1;
		else if(localStorage.token){
			return 0;
		}
		else{
			return -1;
		}
	}

	toggleMobileMenu = () => {
		this.setState({ mobileMenuOpen: !this.state.mobileMenuOpen });
	};

	closeMobileMenu = () => {
		this.setState({ mobileMenuOpen: false });
	};

	handleNavClick = (path) => {
		history.navigate(path);
		this.closeMobileMenu();
	};

	// checkPopupOpen = () => {
	// 	var popupArray = PopupController.state.components;
	// 	var popupOpen;
	// 	for(var i = 0; i < popupArray.length; i++){
	// 		if(popupArray[i].show = true){
	// 			popupOpen = true;
	// 		}
	// 	}
	// 	return popupOpen;
	// }

	render() {
		return (
			<div role="banner" className="g-nav-bar">
				<img tabIndex={this.canSelectWithTab()}
					onClick={() => {
						history.navigate('/');
					}}
					src={logo}
					alt="Company Logo"
					className={classNames('g-nav-bar-logo', { 'mobile-hidden': !this.state.mobileMenuOpen })}
				/>

			<div></div>
			<div 
				ref={(ref) => { this.menuRef = ref; }}
				className={classNames('g-nav-bar-menu', { 'mobile-open': this.state.mobileMenuOpen })}
			>
				<button
					ref={(ref) => { this.hamburgerInsideRef = ref; }}
					className="g-nav-bar-hamburger g-nav-bar-hamburger-inside"
					onClick={this.toggleMobileMenu}
					aria-label="Close menu"
				>
					<img src={hamburgerIcon} alt="Close Menu" />
				</button>
				<div
						tabIndex={this.canSelectWithTab()}
						className={classNames('g-nav-bar-item', { active: this.isActiveTab(['/'], true) })}
						onClick={() => this.handleNavClick('/')}
					>
						Dashboard
					</div>
					<div
						tabIndex={this.canSelectWithTab()}
						className={classNames('g-nav-bar-item', { active: this.isActiveTab(['/drugs', '/drug/']) })}
						onClick={() => this.handleNavClick('/drugs')}
					>
						Drugs
					</div>
					<div
						tabIndex={this.canSelectWithTab()}
						className={classNames('g-nav-bar-item', { active: this.isActiveTab(['/users', '/user']) })}
						onClick={() => this.handleNavClick('/users')}
					>
						Users
					</div>
					<div
						tabIndex={this.canSelectWithTab()}
						className={classNames('g-nav-bar-item', { active: this.isActiveTab(['/units', '/unit', '/drug_box']) })}
						onClick={() => this.handleNavClick('/units')}
					>
						Units & Boxes
					</div>
					<div
						tabIndex={this.canSelectWithTab()}
						className={classNames('g-nav-bar-item', { active: this.isActiveTab(['/reports', '/forms']) })}
						onClick={() => this.handleNavClick('/reports/recommended')}
					>
						Reports
					</div>
					<div
						tabIndex={this.canSelectWithTab()}
						className={classNames('g-nav-bar-item', { active: this.isActiveTab(['/activity']) })}
						onClick={() => this.handleNavClick('/activity')}
					>
						Activity
					</div>
				</div>
        {Boolean(this.state.userGroup && this.state.userGroup.has_overdue_invoice) && <div className={'has-overdue-invoice'}>Your invoice is now more than 30 days past due. Please contact LogRx administrators at info@logrx.com</div>}
				<AccountOptions />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/navBar/NavBar.jsx